module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pago-venta/modal-ticket/modal-ticket.component.scss
// module id = ./src/app/pago-venta/modal-ticket/modal-ticket.component.scss
// module chunks = main